import { render, staticRenderFns } from "./OrderEditDialog.vue?vue&type=template&id=4c8d5326&scoped=true"
import script from "./OrderEditDialog.vue?vue&type=script&lang=js"
export * from "./OrderEditDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderEditDialog.vue?vue&type=style&index=0&id=4c8d5326&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8d5326",
  null
  
)

export default component.exports